import { queryClient } from "../../../../..";

/**
 * 
 * @param {*} param0 
 * @description how the filterOptionsBy config works:
    it expects one property -> filterId.
    from this filterId we get the 'selected filter values' against this filterId.
    what it does is, it filters down the options of THIS FILTER to only those options that are 
    linked via tags to the 'selected filter values'.
    an example to understand this:
    if a states and districts filter exists, and in states filter i have selected maharastra,
    then in the districts filter, only the maharashtra districts will show IF the districts tpl 
    has a tag input for the 'states'.
 */
    export const convertFilterOptionsByConfIntoFindQuery = ({
        filterOptionsBy,
        activeFilters,
        thisFilterConfig,
      }) => {
        
        if(!activeFilters) return {} //abort

        const { filterId } = filterOptionsBy;
        const masterFilter = activeFilters.find((f) => f.filterId === filterId); //i.e the filter whose value will trim down the options of THIS filter
        
        if(!masterFilter) return {} //abort

        switch (true) {
          case masterFilter.source?.filterType === "tagType":
          case masterFilter.target.filterType === "tagType": //this is for backward compat, cuz previously we wouldnt pass the source to activeFilters
            const masterContentType =
              masterFilter.source?.tagType || masterFilter.target.tagType;
            /**
             * so the condition for filterOptionsBy to works is, 'this filter'
             * whose options are being funneled down, should be of 'tagType', and the tpl of this
             * tagType should have been a tag field with master content type. 
             * only then will this work.
             */
            return {
                  [`tags.${masterContentType}.data._id`]: {
                    $in: masterFilter.values.map((v) => v.value),
                  },
                };
      
          default:
            return {};
        }
      };